import styled from 'styled-components'

export const MarkerPopupWrapper = styled.div<{
  open?: boolean
  padded?: boolean
}>`
  cursor: pointer; /* important for receiving correct mobile touch events */
  position: absolute;
  width: 280px;
  left: 50%;
  bottom: 28px;
  background-color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
  padding: ${({ padded }) => (padded ? '8px' : '0')};
  text-align: left;
  border-radius: 6px;
  transform: translate(-50%, 0);
  z-index: 9;
  transition: opacity 300ms ease-out;
  visibility: hidden;
  opacity: 0;

  ${({ open }) =>
    open &&
    `
    opacity: 1;
    visibility: visible;
  `}

  &:before,
  &:after {
    content: '';
    position: absolute;
    left: 50%;
    margin-left: -8px;
    transform: rotate(45deg);
    width: 16px;
    height: 16px;
  }

  &:before {
    bottom: -8px;
    background-color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
  }

  &:after {
    bottom: -7px;
    background-color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
  }
`
